module.exports = __webpack_public_path__ + "img/setting_icon_selected_mobile.81933002.svg";